<template>
  <v-dialog v-model="dialogComputed" scrollable persistent>
    <v-card v-if="dialogComputed">
      <v-card-title class="primary white--text py-2">
        {{ $t('ELE0077') }}
        <v-spacer />
        <Btn icon="mdi-close" @click="onClickClose" depressed iconProp color="white" />
      </v-card-title>
      <v-card-text>
        <v-container fluid>
          <v-row dense class="pt-3">
            <v-col cols="4">
              <FileInput :label="$t('ELE0208')" multiple v-model="filesComputed" required />
            </v-col>
            <v-col>
              <BtnImport class="mt-1" @click="onClickImport" :disabled="filesComputed.length <= 0" />
            </v-col>
            <v-spacer />
          </v-row>
          <v-row>
            <v-col>
              <v-card outlined>
                <v-card-title>
                  {{ $t('ELE0077') }}
                </v-card-title>
                <v-card v-if="errorList.length > 0" outlined class="mx-auto" color="red lighten-5" width="600px">
                  <v-card-title class="text-h5 justify-center">
                    {{ $t('MSG0039') }}
                  </v-card-title>
                  <v-card-text class="text-h6 font-weight-normal black--text">
                    <v-row>
                      <v-col class="d-flex flex-row">
                        <span class="mx-3">
                          <v-avatar color="red" size="36" class="px-2">
                            <v-icon color="white">mdi-exclamation-thick</v-icon>
                          </v-avatar>
                        </span>
                        <span class="pt-1">{{ $t('MSG0040', { p0: errorLineCount }) }}</span>
                        <v-spacer />
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
                <v-card-text>
                  <v-data-table v-if="errorList.length > 0" dense :headers="headers" :items="errorList">
                    <template v-slot:item.detail="{ item }">
                      <div class="py-1" style="white-space: pre">{{ item.detail }}</div>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import Btn from '@/components/atoms/base/button/Btn'
import BtnClose from '@/components/atoms/button/BtnClose'
import BtnImport from '@/components/atoms/button/BtnImport'
import FileInput from '@/components/atoms/base/file/FileInput'

export default {
  name: 'ImpDataErrorDialog',

  components: {
    Btn,
    BtnClose,
    BtnImport,
    FileInput,
  },

  props: {
    dialog: {
      type: Boolean,
      default: false,
      required: true,
    },
    files: {
      type: Array,
      default: () => [],
      required: true,
    },
    errorList: {
      type: Array,
      default: () => [],
      required: true,
    },
    errorLineCount: {
      type: Number,
      default: 0,
      required: true,
    },
  },

  computed: {
    dialogComputed: {
      get() {
        return this.dialog
      },
      set(value) {
        this.$emit('update:dialog', value)
      },
    },
    filesComputed: {
      get() {
        return this.files
      },
      set(value) {
        this.$emit('update:files', value)
      },
    },
  },

  data() {
    return {
      headers: [
        { text: this.$t('ELE0209'), value: 'fileName', divider: true, width: '270' },
        { text: this.$t('ELE0084'), value: 'line', divider: true, width: '130', align: 'end' },
        { text: this.$t('ELE0085'), value: 'detail' },
      ],
    }
  },

  methods: {
    onClickClose() {
      this.dialogComputed = false
    },
    onClickImport() {
      this.dialogComputed = false
      this.$emit('import')
    },
  },
}
</script>
